<script>
export default {
    render (h) {
      return h('button', {
        on: { click: this.popupClicked}
        },
        [
          h('img', { 
            domProps: { 'src': '/map-pin-btn.png' }
          })
        ]
      )
    },

  name: 'pinpopup',
  props: {
     mapboxPopup: Object,
     clickedPoint: Array,
  },
  methods: {
    popupClicked() {
//      this.mapboxPopup.remove();
      var point = {
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": [
            this.clickedPoint[0],
            this.clickedPoint[1]
          ],
          "id": this.clickedPoint[2].id,
        },
        "properties": {
          "id": String(new Date().getTime())
        }
      };
      this.$emit('newPoint', point);
//      self.mapPinGeoJson.features.push(point);
//      self.$refs.mapboxcomponent._map.getSource('mappin-source').setData(self.mapPinGeoJson);

      /*
      var el = document.createElement('div');
      el.className = 'marker';
      new mapboxgl.Marker(el)
          .setLngLat(this.clickedPoint)
          .addTo(map);
      */
    },
  }
};
</script>
